import ReactDOM from "react-dom/client";
import App from "@/App";
import storageService from "@/services/middleware/storageService";
import { version } from "$root/package.json";
const root = ReactDOM.createRoot(
  document.getElementById("app") as ReactDOM.Container
);

root.render(<App />);

if (localStorage) {
  storageService.setItem("version", version);
}
